export class MetaSitePermissionPass {
  constructor(private levels: string[] = []) {}

  isAllowed(context: any, next: any) {
    if (!this.levels.includes(context.level)) return false;

    return next();
  }
}
